import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    const { refetch } = context.authentication;

    await refetch().then(
      (response) => {
        if (!response.data) {
          throw redirect({
            to: "/home",
            search: { loggedOut: false },
          });
        }
        throw redirect({
          to: "/app",
        });
      },
      () => {
        throw redirect({
          to: "/home",
          search: { loggedOut: false },
        });
      }
    );
  },
  component: Outlet,
});
